export default "__VITE_ASSET__DGiDrvMc__"